import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-forestDeep text-mutedDark" data-id="element-88" data-mp="3geze367ujv27">
      <div className="harvest-bar h-2 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggk7gsifd7yh" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32onl753ftsa0">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="36pfutzg81z6t">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="3uf0nja26gata">Created by earth science specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-lineDark pt-6 text-xs" data-id="element-93" data-mp="38qtcrvhxfo0">
          © 2026 {productName} — All rights reserved.
        </p>
      </div>
    </footer>;
}